import { useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { useClassroom } from '../state/Classroom';

export default function Account() {
  const { session, student, role } = useClassroom();
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<{ ok: boolean; text: string } | null>(null);

  const change = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password.length < 6) { setMsg({ ok: false, text: 'Use at least 6 characters.' }); return; }
    setBusy(true); setMsg(null);
    const { error } = await supabase.auth.updateUser({ password });
    setBusy(false);
    if (error) setMsg({ ok: false, text: error.message });
    else { setPassword(''); setMsg({ ok: true, text: 'Password changed.' }); }
  };

  return (
    <div className="narrow">
      <h1>Account</h1>
      <p className="sub">
        {role === 'student' && student
          ? <>Signed in as <strong>{student.username}</strong> ({student.display_name}).</>
          : <>Signed in as <strong>{session?.user.user_metadata?.display_name || session?.user.email}</strong>
            {session?.user.user_metadata?.display_name && <> ({session.user.email})</>}, teacher.</>}
      </p>

      <form className="panel" onSubmit={change}>
        <div className="field">
          <label htmlFor="pw">New password</label>
          <input
            id="pw" type="password" autoComplete="new-password"
            value={password} onChange={e => setPassword(e.target.value)}
          />
        </div>
        {msg && <div className={`notice small ${msg.ok ? 'good' : 'bad'}`} style={{ marginBottom: 14 }}>{msg.text}</div>}
        <button className="primary" type="submit" disabled={busy || !password}>
          {busy ? 'Saving…' : 'Change password'}
        </button>
      </form>

      {role === 'student' && (
        <div className="panel" style={{ marginTop: 16 }}>
          <strong>My class</strong>
          <p className="small muted" style={{ margin: '4px 0 10px' }}>Switch classes, or join another one with a class code.</p>
          <Link to="/classes" className="button small">Open my classes</Link>
        </div>
      )}

      <div className="row" style={{ marginTop: 24 }}>
        <button onClick={() => supabase.auth.signOut({ scope: 'local' })}>Sign out</button>
      </div>
    </div>
  );
}
